export const amILoading = (userId: string, isGettingUserWithId: string) =>
{
  if(userId === isGettingUserWithId) return true;
  return false
}